var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShowView',{attrs:{"module":_vm.module,"model":_vm.model,"show-item":_vm.showItem,"view-config":_vm.viewConfig,"fetch":_vm.fetch,"namespace":'road-maintenance/task'}})}
var staticRenderFns = []

export { render, staticRenderFns }